import { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import useClientConfig from "../common/hooks/clientConfigHook";

export function useSpecializedTranslation(job) {
  const { t: baseT, i18n } = useTranslation();
  const clientConfig = useClientConfig();

  const possibleKeys = useMemo(() => {
    const possibleKeys = [];
    const site = job?.site;
    const level = job?.level;

    if (clientConfig.enableSites && clientConfig.enableLevels && site && level) {
      possibleKeys.push(`${site}_${level}`);
    }
    if (clientConfig.enableLevels && level) {
      possibleKeys.push(`${level}`);
    }
    if (clientConfig.enableSites && site) {
      possibleKeys.push(`${site}`);
    }
    return possibleKeys;
  }, [clientConfig.enableSites, clientConfig.enableLevels, job?.site, job?.level]);

  const t = useCallback((key, options) => {
    if (possibleKeys.length) {
      for (const k of possibleKeys) {
        const lookupKey = `${k}_${key}`;
        const tres = baseT(lookupKey, options);

        if (tres !== lookupKey) {
          return tres;
        }
      }
    }
    return baseT(key, options);
  }, [baseT, possibleKeys]);

  const toReturn = useMemo(() => ({ t: clientConfig.enableJobTranslation ? t : baseT, i18n }), [clientConfig.enableJobTranslation, t, baseT, i18n]);
  return toReturn;
}
